import { useState } from "react";
import { toast } from "react-toastify";

import { Typography, Button, Input } from "@atoms";
import { theme } from "@theme";
import { Container, Wrapper } from "./feedback.styles";
import { axiosInstance } from "utils";
import { Form } from "antd";
import { useTranslation } from "react-i18next";

function Feedback() {
  const {t} = useTranslation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [form] = Form.useForm();
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      await axiosInstance.post("/feedback_forms/", {name, email: email.toLowerCase(), message});

      toast.success("Сообщение успешно отправлена!", {
        position: "bottom-right",
        theme: "colored",
      });
    } catch (error) {
      toast.error(t("somethingerr"), {
        position: "bottom-right",
        theme: "colored",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleValuesChange = async () => {
    form
      .validateFields()
      .then(() => {
        setIsDisabled(false);
      })
      .catch((err) => {
        setIsDisabled(!!err.errorFields.length);
      });
  };

  return (
    <Wrapper>
      <Container>
        <Typography as="h2">{t("feedback")}</Typography>
        <Typography
          as="label"
          style={{
            color: "rgba(6, 6, 6, 0.8)",
            textAlign: "center",
            marginTop: "-8px",
          }}
        >
          {t("feedbackEmail")} <br/> {t("feedbackEmail2")}
        </Typography>
        <Form
          style={{width: "100%"}}
          form={form}
          layout="vertical"
          onValuesChange={handleValuesChange}
          requiredMark={false}
        >
          <Form.Item
            label={t("name")}
            name="name"
            rules={[{required: true, message: t("writeName")}]}
          >
            <Input
              name="name"
              form={form}
              value={name}
              onChange={setName}
              placeholder={t("writeName")}
            />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {required: true, message: t("writeEmail")},
              {
                type: "email",
                message: t("emailError"),
              },
            ]}
          >
            <Input
              name="email"
              form={form}
              value={email}
              onChange={setEmail}
              placeholder={t("writeEmail")}
            />
          </Form.Item>
          <Form.Item
            label={t("message")}
            name="message"
            rules={[{required: true, message: t("emailMessage")}]}
          >
            <Input
              name="message"
              form={form}
              value={message}
              onChange={setMessage}
              placeholder={t("emailMessage")}
            />
          </Form.Item>
        </Form>

        <Button
          variant="primary"
          size="large"
          fullWidth
          disabled={isDisabled}
          loading={isLoading}
          onClick={handleClick}
        >
          <Typography style={{color: theme.palette.default}}>
            {t("continue")}
          </Typography>
        </Button>
        <Typography
          as="a"
          href="/my-stories"
          style={{color: theme.palette.primary, marginTop: "-16px"}}
        >
          {t("gtmain")}
        </Typography>
      </Container>
    </Wrapper>
  );
}

export default Feedback;
